import styled from '../../../../../styles/theme';
import { PriceBoxStyledOV as PriceBoxStyled } from '../PriceBoxStyled.OV';

export const PriceBoxStyledOV = styled(PriceBoxStyled)`
 
`;
